// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3PJPp","description":"PatientConsentPreview_description__H0Yri"};